export default class PortConfig {
	httpPort: number = 0;
	httpsPort: number = 0;
	grpcPort: number = 0;
	grpcSecurePort: number = 0;
}